import React from 'react';
import { MousePointerClick, Send, Package } from 'lucide-react';

const STEPS = [
  { icon: MousePointerClick, title: '1. Pick Your Style', text: 'Browse over 100 handpicked bow ties, neckties, and sets. Add your favorites to the cart.' },
  { icon: Send, title: '2. Send Your Order', text: 'Place your order request — Johnnie will personally confirm it and send you a Square invoice by email.' },
  { icon: Package, title: '3. Pay & It Ships', text: 'Pay securely through Square. Flat $9.99 shipping on every order, straight to your door.' },
];

const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="py-14 bg-[#E6D7B3]/25 border-y border-[#E6D7B3]/50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-2xl sm:text-3xl font-serif font-bold text-[#001B2A] text-center mb-10">How It Works</h2>
      <div className="grid sm:grid-cols-3 gap-8">
        {STEPS.map(({ icon: Icon, title, text }) => (
          <div key={title} className="text-center" data-testid={`how-step-${title[0]}`}>
            <div className="inline-flex items-center justify-center w-14 h-14 bg-[#001B2A] rounded-full mb-4">
              <Icon className="h-7 w-7 text-[#E6D7B3]" />
            </div>
            <h3 className="text-lg font-serif font-bold text-[#001B2A] mb-2">{title}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
